import React, {FunctionComponent, createContext, useContext, useState, useEffect} from 'react';
import FavoritesRepository from '../networking/repos/FavoritesRepository';
import {info} from '../utils/Toast';

export interface IFavoritesContext {
    toggleFavorite: (university: number) => void;
    favoriteUniversities: number[];
}

const FavoritesContext = createContext<IFavoritesContext>({} as IFavoritesContext);
export const useFavorites = () => useContext(FavoritesContext);

interface Props {
    children: any;
}

const FavoritesContextProvider: FunctionComponent<Props> = ({ children }) => {

    const [favoriteUniversities, setFavorites] = useState<number[]>([]);

    const [repo] = [
        new FavoritesRepository()
    ];

    useEffect(() => {
        repo.all().then(setFavorites);
    }, []);

    const toggleFavorite = async (university: number) => {
        const isFavorite = favoriteUniversities.includes(university);

        const favorites = await repo.toggleFavorite(university);
        setFavorites(favorites);

        info(isFavorite
            ? 'Removed university as favorite!'
            : 'Added university to favorites!'
        );
    };

    return (
        <FavoritesContext.Provider value={{ favoriteUniversities, toggleFavorite }}>
            { children }
        </FavoritesContext.Provider>
    );
};

export default FavoritesContextProvider;
